import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { rootCssSet } from "../../utils/helpers/common";

const initialState = {
  sendInviteDialog: false,
  filterDialog: false,
  invitesListReset:false
};

export const manageInvitesSlice = createSlice({
  name: "manage invites",
  initialState,
  reducers: {
    setInviteDialog: (state) => {
      state.sendInviteDialog = !state.sendInviteDialog;
    },

    setFilterDialog: (state) => {
      state.filterDialog = !state.filterDialog;
        rootCssSet();
    },

    setInvitesListReset: (state) => {
      state.invitesListReset = !state.invitesListReset;
    },
  },
});

export const manageInvitesAction = manageInvitesSlice.actions;
export const manageInvitesReducer = manageInvitesSlice.reducer;
